<wiz-root>
  <menu-bar></menu-bar>
  <router-outlet></router-outlet>
</wiz-root>
